export const SECURITY_REQUEST = 'SECURITY_REQUEST';
export const SECURITY_FAILURE = 'SECURITY_FAILURE';
export const SECURITY_SUCCESS = 'SECURITY_SUCCESS';
